import MenuItem from '@mui/material/MenuItem'
import Field from 'components/ui/Field'
import { ChangeEventHandler } from 'react'

import InlineLabel from './InlineLabel'
import TextField from './TextField'

interface Props {
  value?: string | number
  label?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  name?: string
  options: {
    label: string
    value: string | number
  }[]
  testid?: string
}

function SelectField(props: Props) {
  const { name, label, value, onChange, options, testid } = props

  const menuItems = options.map(({ label: itemLabel, value }) => (
    <MenuItem key={itemLabel} value={value}>
      {itemLabel}
    </MenuItem>
  ))

  const labelNode = <InlineLabel>{label}</InlineLabel>

  return (
    <Field label={labelNode} inline>
      <TextField
        variant="standard"
        select
        name={name}
        margin="dense"
        value={value}
        onChange={onChange}
        SelectProps={{ displayEmpty: true }}
        data-testid={testid}
      >
        {menuItems}
      </TextField>
    </Field>
  )
}

export default SelectField
